/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetCurrentEtcCard200ResponseHolder } from './get-current-etc-card200-response-holder';
// May contain unused imports in some cases
// @ts-ignore
import { GetCurrentEtcCard200ResponseUserAccountGroup } from './get-current-etc-card200-response-user-account-group';

/**
 * 
 * @export
 * @interface GetCurrentEtcCard200Response
 */
export interface GetCurrentEtcCard200Response {
    /**
     * ETC card ID
     * @type {string}
     * @memberof GetCurrentEtcCard200Response
     */
    'cardId': string;
    /**
     * Card name (max 64 characters)
     * @type {string}
     * @memberof GetCurrentEtcCard200Response
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof GetCurrentEtcCard200Response
     */
    'cardStatus': GetCurrentEtcCard200ResponseCardStatusEnum;
    /**
     * 
     * @type {GetCurrentEtcCard200ResponseHolder}
     * @memberof GetCurrentEtcCard200Response
     */
    'holder': GetCurrentEtcCard200ResponseHolder;
    /**
     * 
     * @type {GetCurrentEtcCard200ResponseUserAccountGroup}
     * @memberof GetCurrentEtcCard200Response
     */
    'userAccountGroup'?: GetCurrentEtcCard200ResponseUserAccountGroup | null;
    /**
     * User account ID
     * @type {string}
     * @memberof GetCurrentEtcCard200Response
     */
    'userAccountId': string;
    /**
     * Last four digits of the ETC card ID for display
     * @type {string}
     * @memberof GetCurrentEtcCard200Response
     */
    'etcIdLastFourDigits'?: string | null;
}

export const GetCurrentEtcCard200ResponseCardStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type GetCurrentEtcCard200ResponseCardStatusEnum = typeof GetCurrentEtcCard200ResponseCardStatusEnum[keyof typeof GetCurrentEtcCard200ResponseCardStatusEnum];


